import api from './api';

export const notificationService = {
  // Get in-app notifications
  getInAppNotifications: async () => {
    return api.get('/notifications/in-app');
  },

  // Send payment reminder to a debtor
  sendReminder: async (debtorId) => {
    return api.post(`/notifications/debtors/${debtorId}/reminder`);
  },

  // Send bulk reminders (Basic+ only)
  sendBulkReminders: async (minOutstanding = 0) => {
    return api.post(`/notifications/bulk-reminders?minOutstanding=${minOutstanding}`);
  },

  // Get notification history
  getHistory: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    return api.get(`/notifications/history?${params}`);
  },

  // Get notification statistics
  getStats: async (startDate, endDate) => {
    const params = new URLSearchParams({ startDate, endDate }).toString();
    return api.get(`/notifications/stats?${params}`);
  },

  // Test SMS
  testSMS: async (mobile, message) => {
    return api.post('/notifications/test/sms', { mobile, message });
  },

  // Test WhatsApp
  testWhatsApp: async (mobile, message) => {
    return api.post('/notifications/test/whatsapp', { mobile, message });
  }
};
